import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { featureName, reducer, TaskEditorEffects } from '@app/+task-editor/store';
import { EffectsModule } from '@ngrx/effects';

@NgModule({
    imports: [
        StoreModule.forFeature(featureName, reducer),
        EffectsModule.forFeature([TaskEditorEffects])
    ]
})
export class TaskEditorStateModule { }
